import React from "react";

/**
 * InputComponent renders an input field with validation.
 *
 * @typedef {object} InputProps
 * @property {string} name - Name of the input field.
 * @property {string} [label=''] - Label of the input field.
 * @property {string} [labelClass=''] - Class name of the Label.
 * @property {string} [placeholder=''] - Placeholder text of the input field.
 * @property {string} [type='text'] - Input type of the input field.
 * @property {Function} register - Function to register the input field for form
 * @property {Object} [error=null] - Object containing validation error.
 * @property {Function} handleChange - Callback function when input changes.
 * @property {Function} handleFocus - Callback function when input focuses.
 * @property {Function} handleBlur - Callback function when input blurs.
 * @property {string} [fieldStyle='flex-between flex-row-center'] - Style for Form.Field.
 * @property {string} [selectContainerStyle='w-100'] - Style for toggle buttons container.
 *
 * @component
 * @param {InputProps} props - The component props.
 * @returns {JSX.Element} The rendered input field with validation.
 */
export default function InputComponent({ name, register, handleChange }) {
  return (
    <input
      {...register(name, {
        onChange: (e) => {
          handleChange();
        },
      })}
      type="hidden"
    />
  );
}
